<template>
  <div class="MapPopup">
    <!-- 地图弹框切换 -->
    <span>弹框切换</span>
    <el-select @change="mapPourChange"
               v-model="curreentBorderName"
               popper-class="MapPopup"
               placeholder="请选择弹框">
      <el-option v-for="item in mapPour"
                 :key="item.value"
                 :label="item.label"
                 :value="item.value">
      </el-option>
    </el-select>
  </div>
</template>
<script>

import { mapMutations, mapState } from 'vuex';
export default {
  name: 'MapPopup',
  props: {
    CurrentConfigration: Object,
    propertyData: Object,
    propertyDataKey: String,
  },
  data () {
    return {
      mapPour: [
        {
          value: 'point',
          label: '点位弹框'
        },
        {
          value: 'video',
          label: '监控弹框'
        },
      ],
      curreentBorderName: ''
    }
  },
  created () {
    this.initData();
  },
  computed: {
    ...mapState({
      // 点位
      pointList: state => state.pointList,
    }),
  },
  methods: {
    initData () {
      this.curreentBorderName = this.CurrentConfigration.propertyData.mapPopupData.value.mapComponentName;
    },
    mapPourChange (val) {
      let sendVal = {
        mapComponentName: val,
      };
      this.commitCurrentPropertyData(sendVal);
    },
    commitCurrentPropertyData (val) {
      this.$store.commit('update_PropertyData', {
        key: this.propertyDataKey,
        value: val,
      });

      let VideoData = {
        Video: this.pointList.Video,
        SwitchValue: val.mapComponentName
      }
      this.$store.commit('setPointList', VideoData);

    },
  }
}
</script>
<style lang="scss" scoped>
.MapPopup {
  width: 100%;
  margin: 10px 0;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .el-select {
    width: 150px;
  }
  span {
    box-sizing: border-box;
    color: $property-title-color;
    font-size: $property-title-size;
  }
  padding: 0 15px;
  :deep().el-input input {
    height: 35px;
    color: #b6b8cc;
    background: #191b23;
    text-align: center;
    border: 1px solid rgba(139, 139, 139, 0.733);
    &:hover {
      border: 1px solid #3179ff;
    }
    &:focus {
      border: 1px solid #3179ff;
    }
  }
}
</style>